import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Chip } from "@mui/material";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../services/mainApi.service";
import { ITemplateGenerals } from "../../../../models/template-general";

const TEMPLATE_GENERAL_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TemplateGeneral/";
const templateGeneralService = new MainApi<ITemplateGenerals>(
  TEMPLATE_GENERAL_ROUTE
);

const translationPath = "chatBot.page.automations.templateGeneral.";

const TemplateGeneralPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const columns: GridColDef<ITemplateGenerals>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "contentHeader",
      headerName: t(translationPath + "content_header") || "Content Header",
    },
    {
      field: "contentFooter",
      headerName: t(translationPath + "content_footer") || "Content Footer",
    },
    {
      field: "templateGeneralType",
      headerName:
        t(translationPath + "template_general_type") || "Template General Type",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 120,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<ITemplateGenerals>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<ITemplateGenerals>
      showDefaultMacroFilters={false}
      service={templateGeneralService}
      columns={columns}
      title={t(translationPath + "title") || "General Templates"}
      searchInput={false}
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for general template"
      }
      addButtonLabel={t(translationPath + "add") || "Add General Template"}
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default TemplateGeneralPage;
